<script setup lang="ts">
interface props {
  compliances?: string[]
  exceptions?: string[]
  requirements?: string[]
}

const props = defineProps<props>()

const data = computed(() => {
  const { compliances, exceptions, requirements } = props
  const info = [
    {
      data: compliances ?? [],
      title: 'Qué cubre',
      icon: 'ph--check-circle-bold',
    },
    {
      data: exceptions ?? [],
      title: 'Qué no cubre',
      icon: 'ph--x-circle-bold',
    },
    {
      data: requirements ?? [],
      title: 'Requisitos',
      icon: 'ph--info-bold',
    },
  ]
  return info.filter((l) => l.data?.length && l.data.length > 0)
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <template
      v-for="(d, i) in data"
      :key="i"
    >
      <div v-if="i > 0">
        <PvDivider />
      </div>
      <ListComponent
        :items="d.data"
        :title="d.title"
        :icon="d.icon"
      />
    </template>
  </div>
</template>
